import { IAdminprofileUser, IPreviewAgentprofile, } from 'atlas-shared/dist';
import { RestRequest, } from '@Utils';

export * from './abstract/adminprofile.api.abstract';

export const fetchAdminprofileUsers = async (id: IPreviewAgentprofile['id']): Promise<Array<IAdminprofileUser>> => {
  return RestRequest.get<Array<IAdminprofileUser>>(`adminprofile/${id}/users`, { socket_id: global.socketId, });
};
